// PharuERP — Design System Bloco D (Indigo-violet)
// =================================================
// Refatorado em 2026-XX-XX (Sprint 1 Foundation): os valores agora
// apontam pra CSS custom properties (var(--*)) definidas em
// src/styles/canonical/tokens.css. Isso elimina drift entre dois
// sistemas de tokens (CSS vs JS), e o dark/light theming passa a
// ser controlado por [data-theme] no <html> — sem re-render React.
//
// Como funciona:
//   - lightTheme e darkTheme têm os MESMOS valores (todos var(--*))
//   - quando ThemeContext muda [data-theme="dark"] no <html>,
//     o browser resolve as variáveis automaticamente
//   - styled-components legacy (${({ theme }) => theme.accent})
//     continua funcionando sem mudança — recebe a string "var(--accent)"
//     e o browser resolve no momento do paint
//
// Tokens legados (purple, lime, orange, today, wood, status*) ficam
// como aliases pra tokens canônicos (--accent-soft, --success-*, etc).
// Remover só quando o módulo correspondente migrar pra usar diretamente
// var(--*) ou for refatorado pra usar tones canônicos (info/success/warning/danger/neutral).
//
// Fonte canônica dos tokens:
//   src/styles/canonical/tokens.css (importado em src/index.jsx)

const canonicalTheme = {
  // ---- Brand tokens — agora apontando pra accent canônico ----
  // brandAccent é o accent principal (violet #5B5BF6 em light, #8B8BFF em dark)
  brandInk: "var(--ink)",
  brandPaper: "var(--bg)",
  brandBlock: "var(--ink)",
  brandChannel: "var(--bg)",
  brandAccent: "var(--accent)",

  // ---- App tokens ----
  background: "var(--bg)",
  surface: "var(--surface)",
  surfaceAlt: "var(--surface-2)",
  border: "var(--border)",
  textPrimary: "var(--ink)",
  textSecondary: "var(--ink-2)",
  textTertiary: "var(--ink-3)",
  accent: "var(--accent)",
  accentDeep: "var(--accent-active)",

  // ---- Functional palette (info/warning/danger/success/neutral) ----
  infoSurface: "var(--info-bg)",
  infoBorder: "var(--info-border)",
  infoText: "var(--info-text)",
  warningSurface: "var(--warning-bg)",
  warningBorder: "var(--warning-border)",
  warningText: "var(--warning-text)",
  dangerSurface: "var(--danger-bg)",
  dangerBorder: "var(--danger-border)",
  dangerText: "var(--danger-text)",
  successSurface: "var(--success-bg)",
  successBorder: "var(--success-border)",
  successText: "var(--success-text)",
  neutralSurface: "var(--neutral-bg)",
  neutralBorder: "var(--neutral-border)",
  neutralText: "var(--neutral-text)",

  // ---- Legacy/domain tokens (aliases pra tokens canônicos) ----
  // Mantidos pra não quebrar UI atual; remover por módulo na migração.
  purpleSurface: "var(--accent-soft)",
  purpleBorder: "var(--accent-soft-2)",
  purpleText: "var(--accent)",
  limeSurface: "var(--success-bg)",
  limeBorder: "var(--success-border)",
  limeText: "var(--success-text)",
  orangeSurface: "var(--warning-bg)",
  orangeBorder: "var(--warning-border)",
  orangeText: "var(--warning-text)",
  todaySurface: "var(--warning-bg)",
  todayBorder: "var(--warning-border)",
  todayText: "var(--warning-text)",
  statusRed: "var(--danger-bg)",
  statusGreen: "var(--success-bg)",
  statusYellow: "var(--warning-bg)",
  statusRedText: "var(--danger-text)",
  statusGreenText: "var(--success-text)",
  statusYellowText: "var(--warning-text)",
  // Wood (marcenaria) — sem equivalente direto; aliases provisórios
  // pra tokens warning (laranja/marrom). Substituir por tokens dedicados
  // se a marca quiser preservar esse feel especificamente.
  woodLight: "var(--warning-bg)",
  woodMid: "var(--warning-border)",
  woodDark: "var(--warning-solid)",
  woodGrain: "var(--warning-text)",
};

// Light e Dark expostos como objetos separados pra retrocompat com
// ThemeProvider — na prática são iguais; o que muda é o [data-theme]
// no <html> que faz o browser resolver as variáveis dinamicamente.
export const lightTheme = canonicalTheme;
export const darkTheme = canonicalTheme;
